/** 보조 파일 편집기 UI 등록 — MARS 결선(.nml)·FMU 실행 구성(init.yaml) 슬롯의 구조화 편집기(P5). 부트스트랩이 import */
import { registerParticipantUi } from '@/app/participants/participantUi';

registerParticipantUi('mars', { auxEditors: { companion: () => import('./MarsCouplingEditor') } });
registerParticipantUi('fmu', { auxEditors: { runConfig: () => import('./FmuInitEditor') } });
